import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4504698c")

_pushScopeId("data-v-4504698c")
const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titlename,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.visible = $event)),
    width: "800px",
    "before-close": _ctx.onCancel
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSubmit
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.formData,
        "label-width": "auto"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "报警类型code:",
            prop: "alarmTypeCode"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.alarmTypeCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.alarmTypeCode = $event)),
                disabled: _ctx.isdisable
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "报警类型名称:",
            prop: "alarmTypeName"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.alarmTypeName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.alarmTypeName = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "报警分类:",
            prop: "alarmClassify"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.alarmClassify,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.alarmClassify = $event)),
                placeholder: "请选择报警分类"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "违规",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "报警",
                    value: 2
                  }),
                  _createVNode(_component_el_option, {
                    label: "提醒",
                    value: 3
                  }),
                  _createVNode(_component_el_option, {
                    label: "风控",
                    value: 4
                  }),
                  _createVNode(_component_el_option, {
                    label: "故障",
                    value: 5
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "报警等级:",
            prop: "alarmLevel"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.alarmLevel,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.alarmLevel = $event)),
                placeholder: "请选择报警等级"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "一级",
                    value: 0
                  }),
                  _createVNode(_component_el_option, {
                    label: "二级",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "三级",
                    value: 2
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "系统分类:",
            prop: "systemClassify"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.systemClassify,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.systemClassify = $event)),
                placeholder: "请选择系统分类"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_option, {
                    label: "报警",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "超速报警",
                    value: 2
                  }),
                  _createVNode(_component_el_option, {
                    label: "超时驾驶报警",
                    value: 3
                  }),
                  _createVNode(_component_el_option, {
                    label: "制动报警",
                    value: 4
                  }),
                  _createVNode(_component_el_option, {
                    label: "故障",
                    value: 5
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
})